module.exports = __webpack_public_path__ + "img/google.cf284053.svg";